export const verificationPath = '/api/fastly-verification';
export const statuses = [
  'new',
  'started',
  'processing',
  'captcha_prompted',
  'complete',
  'error'
] as const;
export type VerificationStatus = (typeof statuses)[number];
export type VerificationMessage = {
  channel: 'fastly-verification';
  version: 1;
  attemptId: string;
} & (
  | { type: 'ready' | 'cancel' }
  | { type: 'status'; status: VerificationStatus }
  | { type: 'integration-error'; reason: 'script-error' | 'host-missing' }
);

export function isVerificationMessage(value: unknown): value is VerificationMessage {
  let valid = false;
  if (value && typeof value === 'object') {
    const message = value as Record<string, unknown>;
    valid =
      message.channel === 'fastly-verification' &&
      message.version === 1 &&
      typeof message.attemptId === 'string' &&
      (message.type === 'ready' ||
        message.type === 'cancel' ||
        (message.type === 'status' && statuses.some((status) => status === message.status)) ||
        (message.type === 'integration-error' &&
          ['script-error', 'host-missing'].includes(String(message.reason))));
  }
  return valid;
}
